import { Box } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'

import { AppRefreshProvider } from 'context/AppRefreshContext'
import { getBrandGradient } from 'mui-theme/gradient-utils'
import theme from 'theme'

const BACKGROUND_GRADIENT_OPACITY = 0.2

export const UnauthenticatedRoutesWrapper: React.FC = () => {
  return (
    <AppRefreshProvider>
      <Box
        sx={{
          position: 'relative',
          backgroundColor: theme.colors.gray[0],
          backgroundImage: getBrandGradient(-66, BACKGROUND_GRADIENT_OPACITY)
        }}
      >
        <Outlet />
      </Box>
    </AppRefreshProvider>
  )
}
